<template>
    <div>
        <!-- <v-btn class="dms white--text" color="gray_light" small @click="columnsEditorDialog = true">
            <v-icon left small>mdi-cog-outline</v-icon>
            {{ t('filters::button.select.visible.columns') }}
        </v-btn>
        <v-btn class="dms" color="primary" small @click="saveDialog = true">
            <v-icon left small>mdi-content-save</v-icon>
            {{ t('filters::button.save.filter') }}
        </v-btn>
         -->
        <!-- <v-btn class="dms" color="accent" small @click="savedFiltersDialog = true">
            <v-icon left small>mdi-chevron-down</v-icon>
            {{ t('filters::button.saved.filters') }}
        </v-btn> -->

        <v-dialog v-model="savedFiltersDialog" max-width="500">
            <v-card>
                <v-card-title>
                    {{ t('filters::dialog.title.saved.filters') }}
                </v-card-title>
                <v-card-text>
                    <b-alert v-if="!filters.length" :message="t('filters::saved.filters.no_records')"></b-alert>
                    <v-sheet v-for="filter in userFilters" :key="filter.id">
                        <v-col class="d-md-flex" cols="12">
                            <h6 v-text="filter.name"></h6>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" x-small @click="$emit('filterChange', filter)">
                                <i class="fa fa-filter mr-1"></i>{{ t('default::button.load') }}
                            </v-btn>
                            <span class="mx-1">/</span>
                            <v-btn color="error" x-small @click="deleteFilter(filter)">
                                <i class="fa fa-trash mr-1"></i>{{ t('default::button.delete') }}
                            </v-btn>
                        </v-col>
                    </v-sheet>
                    <v-divider v-if="globalFilters.length"></v-divider>
                    <v-sheet v-for="filter in globalFilters" :key="filter.id">
                        <v-col class="d-flex" cols="12">
                            <h6 v-text="filter.name"></h6>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" x-small @click="$emit('filterChange', filter)">
                                <i class="fa fa-filter mr-1"></i> {{ t('default::button.load') }}
                            </v-btn>
                        </v-col>
                    </v-sheet>
                </v-card-text>
                <v-card-actions>
                    <b-dialog-actions close @close="savedFiltersDialog = false"></b-dialog-actions>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="columnsEditorDialog" max-width="500" @click:outside="triggerChange">
            <v-card class="filters-selector-dialog">
                <v-card-title>
                    {{ t('filters::dialog.title.table_configurator') }}
                </v-card-title>
                <v-card-subtitle class="pt-4">
                    {{ t('filters::dialog.hint.table_configurator') }}
                </v-card-subtitle>
                <v-card-text class="filters-selector-dialog-wrap" style="padding-bottom: 24px !important">
                    <v-sheet v-for="(column, index) in columns" :key="index">
                        <div
                            v-if="column.value !== 'is_patient_mode' && !!column.text"
                            class="d-md-flex align-center py-2"
                        >
                            <v-col class="d-flex align-center py-0" cols="9">
                                <v-switch
                                    v-model="column.isVisible"
                                    class="pt-0"
                                    :label="column.text"
                                    dense
                                    :disabled="column.value === 'actions'"
                                    @change="hideColumn"
                                ></v-switch>
                            </v-col>
                            <v-col class="d-inline-flex py-0 d-flex justify-content-end" cols="3">
                                <!-- <span class="caption text--disabled mr-3" v-text="t('default::label.move')"></span> -->
                                <v-icon
                                    v-if="index > 0"
                                    :disabled="column.value === 'actions'"
                                    :class="`${column.value !== 'actions' ? 'mr-1' : ''}`"
                                    :alt="t('default::button.move.up')"
                                    :title="t('default::button.move.up')"
                                    @click="moveItemToIndex(index, index - 1)"
                                >
                                    mdi mdi-arrow-up
                                </v-icon>
                                <!-- <span v-if="index > 0 && index + 1 < columns.length" class="px-2">/</span> -->
                                <v-icon
                                    v-if="index + 1 < columns.length"
                                    :disabled="column.value === 'actions' || index + 2 === columns.length"
                                    class="ml-1"
                                    :alt="t('default::button.move.down')"
                                    :title="t('default::button.move.down')"
                                    @click="moveItemToIndex(index, index + 1)"
                                >
                                    mdi mdi-arrow-down
                                </v-icon>
                            </v-col>
                        </div>
                    </v-sheet>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="saveDialog" max-width="500">
            <v-card class="page-configurator">
                <v-card-title>
                    {{ t('filters::dialog.title.page_configurator') }}
                </v-card-title>
                <v-card-subtitle class="pt-4">
                    {{ t('filters::dialog.hint.page_configurator') }}
                </v-card-subtitle>
                <v-card-text>
                    <div v-if="allFilters.length" class="saved-filters">
                        <v-row class="load-form">
                            <div class="field">
                                <v-autocomplete
                                    v-model="filterToLoad"
                                    :label="t('filters::label.load_from_saved')"
                                    :items="allFilters"
                                    rounded
                                    clearable
                                    outlined
                                    append-icon="mdi-chevron-down"
                                    dense
                                    @click:clear="clearFilter"
                                ></v-autocomplete>
                            </div>
                            <div></div>
                            <div class="action">
                                <v-btn :disabled="!canLoadFilter" color="primary" rounded @click="loadFilter">
                                    {{ t('filters::button.load') }}
                                </v-btn>
                            </div>
                        </v-row>
                    </div>
                    <div class="save-new-filter">
                        <v-form v-model="newFilterForm" class="w-100">
                            <v-row class="save-form">
                                <div class="field">
                                    <v-text-field
                                        v-model="newFilterName"
                                        :label="'* ' + t('filters::label.save_new')"
                                        :rules="validationRules.name"
                                        :error-messages="errorMessages.name"
                                        dense
                                        rounded
                                        outlined
                                    ></v-text-field>
                                </div>
                                <div class="action">
                                    <!-- :disabled="!newFilterForm"  -->
                                    <v-btn color="primary" rounded @click="createFilter">
                                        {{ t('filters::button.save') }}
                                    </v-btn>
                                </div>
                            </v-row>
                        </v-form>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        route: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            initialHiddenColumns: [],
            loadingFilters: false,
            menu: false,
            newFilterForm: false,
            columnsEditorDialog: false,
            savedFiltersDialog: false,
            saveDialog: false,
            newFilterName: '',
            validationRules: {
                name: [
                    (v) => !!v || t('filters::validation.filter.name.required'),
                    (v) => !this.savedFiltersNames.includes(v) || t('filters::validation.filter.name.unique'),
                ],
            },
            errorMessages: {
                name: [],
            },
        };
    },
    computed: {
        currentTab() {
            return this.$store.state.data_table.tab;
        },
        filterToLoad: {
            get() {
                return this.$store.state.data_table.screenConfiguration.filterToLoad;
            },
            set(value) {
                this.$store.dispatch('data_table/setCurrentScreenConfigurationId', value);
            },
        },
        savedFiltersNames() {
            return this.$store.state.data_table.screenConfiguration.data.map((x) => x.name);
        },
        filters() {
            return this.$store.state.data_table.screenConfiguration.data;
        },
        currentFilter() {
            return this.$store.state.data_table.screenConfiguration.current;
        },
        columns: {
            get() {
                return _.clone(this.$store.state.data_table.columns).map((column) => {
                    column.isVisible = !this.hiddenColumns.includes(column.value);
                    return column;
                });
            },
            set(columns) {
                this.$store.dispatch('data_table/setColumns', columns);
            },
        },
        hiddenColumns: {
            get() {
                return this.$store.state.data_table.hiddenColumns;
            },
            set(hidden) {
                this.$store.dispatch('data_table/setHiddenColumns', hidden);
            },
        },
        canLoadFilter() {
            if (this.filterToLoad) {
                if (this.currentFilter && this.currentFilter.id && this.currentFilter.id === this.filterToLoad) {
                    return false;
                }
                return true;
            }
            return false;
        },
        allFilters() {
            return this.filters.map((x) => ({ text: x.name, value: x.id }));
        },
        userFilters() {
            return this.filters.filter((filter) => {
                return filter.user !== null;
            });
        },
        globalFilters() {
            return this.filters.filter((filter) => {
                return filter.user == null;
            });
        },
    },
    watch: {
        columnsEditorDialog(isOpen) {
            if (isOpen) {
                this.initialHiddenColumns = _.clone(this.hiddenColumns);
            }
        },
    },
    methods: {
        clearFilter() {
            this.saveDialog = false;
            return this.$emit('filterChange', false);
        },
        loadFilter() {
            const filter = this.filters.find((x) => x.id === this.filterToLoad);
            if (!filter) {
                return;
            }
            if (this.currentFilter && this.currentFilter.id && this.currentFilter.id === filter.id) {
                return;
            }
            this.$store.dispatch('data_table/setCurrentScreenConfiguration', filter);
            this.saveDialog = false;
            return this.$emit('filterChange', filter);
        },
        loadFilters() {
            let routes =
                this.route && this.route.template ? this.route.template.replace(/\/(\{.*?\})/, '') : this.route;
            if (this.currentTab !== null) {
                routes = `${routes}/${this.currentTab}`;
            }
            this.$store.dispatch('data_table/loadScreenConfiguration', routes);
        },
        moveItemToIndex(fromIndex, toIndex) {
            let result = _.clone(this.columns);
            let oldItem = _.clone(result[toIndex]);
            result[toIndex] = result[fromIndex];

            result[fromIndex] = oldItem;
            this.columns = result;
            return this.$emit('change', result, 'order');
        },
        hideColumn() {
            this.hiddenColumns = _.filter(this.columns, (column) => !column.isVisible).map((column) => column.value);
        },
        triggerChange() {
            if ((this.hiddenColumns || []).length !== (this.initialHiddenColumns || []).length) {
                return this.$emit('change', this.hiddenColumns, 'hidden');
            }
        },
        createFilter() {
            this.$emit('create', this.newFilterName);
        },
        deleteFilter(filter) {
            axios
                .delete(route('api.v1.filters.destroy', { filter: filter.id }))
                .then(() => {
                    this.loadFilters();
                    this.$root.notify('info', t('filters::notification.filter.deleted'));
                })
                .catch(() => {
                    this.$root.notify('error', t('default::notification.errors.general'));
                });
        },
    },
};
</script>
